import api from './api';

export const exportService = {
  exportQuestionnaireResults: async (params: {
    questionnaireId: number;
    schoolIds?: number[];
    mode: 'ANSWER_TEXT' | 'SCORE';
    academicYear?: string;
  }) => {
    const response = await api.get(
      `/admin/answers/questionnaire/${params.questionnaireId}/export`,
      {
        params: {
          schoolIds: params.schoolIds,
          mode: params.mode,
          academicYear: params.academicYear,
        },
        responseType: 'blob',
        paramsSerializer: (p) => {
          const searchParams = new URLSearchParams();
          if (p.mode) searchParams.append('mode', p.mode);
          if (p.academicYear) searchParams.append('academicYear', p.academicYear);
          if (p.schoolIds) {
            p.schoolIds.forEach((id: number) => searchParams.append('schoolIds', String(id)));
          }
          return searchParams.toString();
        },
      }
    );

    // Extract filename from Content-Disposition header or use default
    const contentDisposition = response.headers['content-disposition'];
    let fileName = '问卷导出结果.xlsx';
    if (contentDisposition) {
      const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?(.+)/i);
      if (match) {
        fileName = decodeURIComponent(match[1].replace(/['"]/g, ''));
      }
    }

    // Create blob URL and trigger download
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};
